<script>
import Layout from '@layouts/main'
import AudioQuality from './audio-quality'
import AboutFooterMenu from './../../../partials/about-footer-menu'

export default {
    components: { Layout, AudioQuality, AboutFooterMenu },
    props: {
        mainComponent: {
            type: String,
            default: 'AudioQuality',
        },
    },
    data() {
        return {
            user: {},
        }
    },
    page() {
        const title = 'Settings'
        const description = 'Settings'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
    computed: {
        isPassSet() {
            return this.$store.state.member.passState === 'set'
        },
        tabs() {
            return [
                {
                    to: { name: 'settings' },
                    label: 'Audio Quality',
                },
            ]
        },
    },
}
</script>

<template>
    <Layout>
        <div class="settings-container">
            <BaseSection padded>
                <h1>Settings</h1>
            </BaseSection>
            <BaseTabPanel
                :tabs="tabs"
                class="tabs"
                is-underlined
                is-unpadded
                address-navigation
            />
            <BaseContent>
                <component :is="mainComponent" />
            </BaseContent>
            <BaseSection
                padded
                class="settings-footer"
            >
                <div class="separator" />
                <AboutFooterMenu/>
            </BaseSection>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.settings-container {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - $size-music-player - $size-menu-bar-height);
    padding-bottom: $s-xxl;
}

.tabs {
    margin-bottom: $s-xxl;
}

.settings-footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1;
    width: 100%;
    padding-top: $s-xxl;
    padding-bottom: $s-xxl;
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    padding: $s-s 0;
    border-top: 1px solid $c-dusty-gray;
    opacity: 0.1;
}

@include desktop {
    .settings-container {
        min-height: calc(100vh - $size-music-player - $s-xl);
        padding-bottom: 0;
    }
}
</style>
